import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useLoading } from '../../../context/LoadingContext';
import BuyerAllUsers from "./AllUsers";
import BuyerRolePermission from "./RolesPermission";


const BuyerUserRoleModule = () => {
    const [activeTab, setActiveTab] = useState("All Users");
    const { setLoading } = useLoading();
    const navigate = useNavigate();
    const tabs = ["All Users", "Roles & Permissions","Invitations"];    
    const renderTabContent = () => {
        switch (activeTab) {
            case "All Users": return <BuyerAllUsers />;
            case "Roles & Permissions": return <BuyerRolePermission />;
            case "Invitations": return <div>Invitations</div>;
            default:
                 return <BuyerAllUsers />;
        }
    };
    return (
        <div className="buyer-layout">
            <div className="amtpl-tabs">
                <div className="content3">
                    <main className="main-content">
                        <div className="mb-3 main-tab">
                            {tabs.map((tab) => (
                                <button
                                    key={tab}
                                    className={`buttonclass ${
                                        activeTab === tab
                                            ? "active"
                                            : "notactive"
                                    }`}
                                    onClick={() => setActiveTab(tab)}
                                >
                                    {tab}
                                </button>
                            ))}
                        </div>
                        <div className="row">{renderTabContent()}</div>
                    </main>
                </div>
            </div>
        </div>
    );
};

export default BuyerUserRoleModule;